(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerSubCategoryDialogController', CustomerSubCategoryDialogController);

    CustomerSubCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomerSubCategory'];

    function CustomerSubCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomerSubCategory) {
        var vm = this;
        vm.customerSubCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:customerSubCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.customerSubCategory.id !== null) {
                CustomerSubCategory.update(vm.customerSubCategory, onSaveSuccess, onSaveError);
            } else {
                CustomerSubCategory.save(vm.customerSubCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
